import { EntityService } from '../../../service/EntityService';

export class GroupProductService extends EntityService {

  static entity = 'api/app/group-product';

  static getAll(): Promise<any> {
    return this.axios.get(`${this.entity}/all`).then(res => res.data);
  }

}
